import { render, staticRenderFns } from "./OrdenCompraComponent.vue?vue&type=template&id=73948173&"
import script from "./OrdenCompraComponent.vue?vue&type=script&lang=js&"
export * from "./OrdenCompraComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports